export default __webpack_public_path__ + "static/media/treso.361a6e4c.jpg";